import firebase from 'firebase/app'
import 'firebase/storage'
import "firebase/auth"
import 'firebase/firestore'

const firebaseConfig1 = {
    apiKey: "AIzaSyCSH-YAtMV9tXsJ7DfrqYF2fQuO0j64Q84",
    authDomain: "workterm2021.firebaseapp.com",
    projectId: "workterm2021",
    storageBucket: "workterm2021.appspot.com",
    messagingSenderId: "612628206409",
    appId: "1:612628206409:web:e74c521608c4ac7c178098",
    measurementId: "G-T5519EBG1C"
}

// const firebaseConfig2 = {

//  different account config

// }

// etc.

firebase.initializeApp(firebaseConfig1)

const storage = firebase.storage()

const currentUser = () => firebase.auth().currentUser

export { storage, currentUser, firebase as default }